import { useEffect, useState } from "react";
import { useAuthedRequest } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";

export function useIBOSearch(term = "", limit = 50) {
  const { logError } = useLogger({ prefix: "useIBOSearch" });
  const [searchResults, setSearchResults] = useState([]);

  const { data, loading, error } = useAuthedRequest(
    term.trim().length < 3
      ? null
      : `/membership/lookup/ibo?term=${encodeURIComponent(term)}&limit=${limit}`
  );

  useEffect(() => {
    if (error) {
      logError(error);
    }
  }, [error]);

  useEffect(() => {
    if (data != null) {
      setSearchResults(data);
    }
  }, [data]);

  return {
    searchResults,
    isLoading: loading,
  };
}
